import { fromEventPattern } from 'rxjs';

export function classChangeObservable(elementNode: Node) {
  return fromEventPattern<void>((handler) => {
    const observer = new MutationObserver((mutations: MutationRecord[]) => {
      for (const mutation of mutations) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class'
        ) {
          handler();
        }
      }
    });

    observer.observe(elementNode, {
      attributes: true,
      attributeFilter: ['class']
    });

    return () => observer.disconnect();
  });
}
